import { orderStatus } from '@/constants';
import { beforeHours } from '@/utils/time';
import { orderService } from '@/services';
import { orderStatusGroupList, orderStatusGroup, } from '@/constants/listControl';
import { MapStore } from '@/lib/map-control/model';
import Order from '@/entity/Order';
import { socketPayloadType } from '@/constants/socketPayloadType';
import { orderTypeCode } from '@/constants/global';
import { initOrderTotal } from '../state';
import { 
// listControlMutationType,
mutationType, } from '../mutations';
export const actionType = {
    /** 컨택스트 메뉴 열기 */
    toggleContextMenu: 'toggleContextMenu',
    getOrder: 'getOrder',
    /** 주문 조회 */
    getOrderList: 'getOrderList',
    clearOrderList: 'clearOrderList',
    addOrder: 'addOrder',
    addSelectedOrderItem: 'addSelectedOrderItem',
    clearSelectedOrderItem: 'clearSelectedOrderItem',
    clearSelectedOrderItems: 'clearSelectedOrderItems',
    setOrderFilter: 'setOrderFilter',
    clearSelectedStoreOrder: 'clearSelectedStoreOrder',
    addSelectedWorkerOrder: 'addSelectedWorkerOrder',
    clearSelectedWorkerOrder: 'clearSelectedWorkerOrder',
    modifyOrder: 'modifyOrder',
    updateOrderCardName: 'updateOrderCardName',
    deleteOrderCardName: 'deleteOrderCardName',
    updateOrderCardApproveNumber: 'updateOrderCardApproveNumber',
    deleteOrderCardApproveNumber: 'deleteOrderCardApproveNumber',
    updateOrder: 'updateOrder',
    updateStatusOrderCount: 'updateStatusOrderCount',
    deleteOrder: 'deleteOrder',
    inputSearchOrderQuery: 'inputSearchOrderQuery',
    setIsHideShareOrder: 'setIsHideShareOrder',
    setMapHoveredOrderId: 'setMapHoveredOrderId',
    setSelectedBySnackbar: 'setSelectedBySnackbar',
    /** 상단 셀렉트 통합 액션 */
    setSelectFilter: 'setSelectFilter',
    resetFilter: 'resetFilter',
    setSortBy: 'setSortBy',
    setStatusTotalCount: 'setStatusTotalCount',
};
// 배달 요청 관련
const action = {
    [actionType.toggleContextMenu]({ state, commit }, payload) {
        if (!('event' in payload)) {
            // eslint-disable-next-line no-param-reassign
            payload.event = state.contextMenu.event;
        }
        commit(mutationType.TOGGLE_CONTEXT_MENU, payload);
    },
    async [actionType.getOrder]({ commit }, orderId) {
        const res = await orderService.getOrder({
            orderId,
        });
        commit('SET_MODAL_ORDER_DATA', res.data);
    },
    async [actionType.getOrderList]({ commit, rootGetters, dispatch, }, hubId) {
        // TODO 목록관제에서 필요 없음
        // const {
        //   mapVisibilitySetting: {
        //     isHideShareOrder,
        //   },
        // } = state;
        const time = new Date().getTime();
        // 현재 기준 24시간 전
        const betweenData = {
            field: 'orderedAt',
            start: beforeHours(time, 24),
            end: time,
        };
        const pageNumber = 1;
        const pageSize = 10_000;
        const payload = {
            pageNumber,
            pageSize,
            betweenData,
        };
        const param = {
            ...payload,
        };
        // 타허브 선택시
        if (hubId) {
            param.hubIds = hubId;
        }
        let data = {};
        try {
            data = await orderService.getListControlOrderList(param);
        }
        catch (error) {
            console.log('[getOrderList]', error);
            return;
        }
        // test 사용시
        // const { data } = dummyOrderList;
        const totalCount = initOrderTotal();
        const storeList = {};
        const orderList = {};
        let cardOrderCount = 0;
        const subscribeHubId = rootGetters['hubSelector/getterSubscribeHubId'];
        data.list.forEach((_order) => {
            const { dropLatitude, dropLongitude, pickupLatitude, pickupLongitude, } = _order;
            const checkedDropPositionOrder = dropLatitude && dropLongitude ? _order
                : {
                    ..._order,
                    dropLatitude: pickupLatitude,
                    dropLongitude: pickupLongitude,
                };
            const order = new Order(checkedDropPositionOrder);
            order.setShareOrder(subscribeHubId);
            const storeId = order.typeCode === orderTypeCode.QUICK ? orderTypeCode.QUICK : order.storeId;
            // TODO 임시 작업. 상점 생성 (퀵이면 quick이라는 상점). -> 퀵에 대해선 추후 디벨롭..
            if (!storeList[storeId]) {
                storeList[storeId] = new MapStore(order);
            }
            storeList[order.storeId].addOrder(order);
            orderList[order.orderId] = order;
            // 아래 내용 목록관제에서 현재 필요 없음 20240607 윤태건
            // 공유주문숨김 판단
            // 공유주문은 숨김설정 + 접수건이면 숨김
            // if (order.isShareOrder && isHideShareOrder && order.isAccepted) {
            //   return;
            // }
            const st = orderStatusGroup[order.statusCode];
            totalCount[st] += 1;
            // 신용카드건수 채크
            if (order.isCardOrder
                && st === orderStatus.DROP_FINISHED.code) {
                cardOrderCount += 1;
            }
        });
        commit(mutationType.SET_CARD_ORDER_COUNT, cardOrderCount);
        commit(mutationType.SET_ORDER_LIST, orderList);
        dispatch(actionType.setStatusTotalCount);
        // commit(mutationType.SET_STATUS_TOTAL_COUNT, totalCount);
    },
    /**
     * 주문상태 카운트 셋팅
     */
    [actionType.setStatusTotalCount]({ commit, getters }) {
        const { getterOrderList, } = getters;
        const totalCount = initOrderTotal();
        Object.values(getterOrderList).forEach(({ statusCode }) => {
            totalCount[orderStatusGroup[statusCode]] += 1;
        });
        commit('SET_STATUS_TOTAL_COUNT', totalCount);
    },
    /**
     * 배달 목록 초기화
     */
    [actionType.clearOrderList]({ commit }) {
        commit('SET_ORDER_LIST', {});
    },
    /**
     * 주문 추가
     * @param 주문 데이터
     * @returns Order 주문 데이터
     */
    [actionType.addOrder]({ commit, rootGetters, dispatch }, pushData) {
        const newOrder = new Order(pushData);
        // 공유건 채크
        const subscribeHubId = rootGetters['hubSelector/getterSubscribeHubId'];
        newOrder.setShareOrder(subscribeHubId);
        dispatch(actionType.updateStatusOrderCount, {
            order: newOrder,
            isPlusFilterGroupCount: true,
            isDeletePrevFilterGroupCount: false,
        });
        // 라이더 혹은 스토어를 선택하지 않았을 경우 주문 리스트에 추가
        commit(mutationType.ADD_ORDER, newOrder);
        return newOrder;
    },
    // 배달 요청 관련 object
    [actionType.addSelectedOrderItem]({ commit }, orderData) {
        commit(mutationType.ADD_SELECTED_ORDER_ITEM_BY_ID, orderData);
    },
    // 배달 요청 특정 아이디 삭제 object
    [actionType.clearSelectedOrderItem]({ commit }, orderId) {
        commit(mutationType.CLEAR_SELECTED_ORDER_ITEM_BY_ID, orderId);
    },
    // 선택된 주문 초기화 object
    [actionType.clearSelectedOrderItems]({ commit }) {
        commit('CELAR_SELECTED_ORDER_ITEMS');
    },
    // 주문 필터 변경
    [actionType.setOrderFilter]({ commit }, filterList = [
        orderStatusGroupList.ALL.code,
    ]) {
        commit('SET_ORDER_FILTER', filterList);
    },
    // 상점 연관 주문 초기화
    [actionType.clearSelectedStoreOrder]({ commit }) {
        commit('SET_SELECTED_STORE_ORDER_LIST', []);
    },
    /**
     * 선택한 라이더 주문 추가
     * @param param0
     * @param workerData
     */
    [actionType.addSelectedWorkerOrder]({ state, commit }, workerData) {
        const { orderList } = state;
        const selectedWorkerOrderList = {};
        const { user } = workerData;
        // TODO 개선 필요
        // 연관 주문을 완전히 가르지 말고 오리진을 둔 상태에서 연관만 추출하는 방식 (워커 연관 참조)
        workerData.orderInfo.forEach(({ orderId }) => {
            const order = orderList[orderId];
            if (!order) {
                console.log(`[addSelectedWorkerOrder] 선택한 라이더의 주문 없음. ${orderId}`);
                return;
            }
            if (order.allocatedWorkerCode === user.code) {
                selectedWorkerOrderList[orderId] = order;
            }
        });
        commit('SET_SELECTED_WORKER_ORDER_LIST', selectedWorkerOrderList);
    },
    /**
     * 라이더 연관 주문 제거
     * @param {*} param0
     * @param {*} orderId
     */
    [actionType.clearSelectedWorkerOrder]({ commit }, orderId) {
        if (orderId) {
            commit('DELETE_SELECTED_WORKER_ORDER_LIST', orderId);
        }
        else {
            commit('CLEAR_SELECTED_WORKER_ORDER_LIST');
        }
    },
    /**
     * 단순 주문 내용 수정. 상태변환 x
     */
    [actionType.modifyOrder]({ commit }, order) {
        commit(mutationType.UPDATE_ORDER, order);
    },
    [actionType.updateOrderCardName]({ commit }, { orderId, cardName }) {
        commit('UPDATE_ORDER_CARD_NAME', {
            orderId,
            cardName,
        });
    },
    [actionType.deleteOrderCardName]({ commit }, orderId) {
        commit('UPDATE_ORDER_CARD_NAME', {
            orderId,
        });
    },
    [actionType.updateOrderCardApproveNumber]({ commit }, { orderId, cardApproveNumber }) {
        commit('UPDATE_ORDER_CARD_APPROVE_NUMBER', {
            orderId,
            cardApproveNumber,
        });
    },
    [actionType.deleteOrderCardApproveNumber]({ commit }, orderId) {
        commit('UPDATE_ORDER_CARD_APPROVE_NUMBER', {
            orderId,
        });
    },
    /**
     * 주문 업데이트 (statusCode 변경등)
     */
    [actionType.updateOrder]({ state, commit, dispatch, rootGetters }, pushData) {
        const newOrder = new Order(pushData);
        const { orderId } = newOrder;
        const oldOrder = state.orderList[orderId];
        // oldOrder가 없는데 주문 완료가 올 경우...? 가 있나?
        oldOrder?.assignOrder(newOrder);
        const newFilterGroup = orderStatusGroup[oldOrder.statusCode];
        const prevFilterGroup = orderStatusGroup[oldOrder.preStatusCode];
        // 이전 주문에 신규 정보 병합 (카운트 업데이트 전에 병합하면 안됨.. 개선 필요)
        if (prevFilterGroup !== newFilterGroup) {
            dispatch(actionType.updateStatusOrderCount, {
                order: oldOrder,
                isPlusFilterGroupCount: true,
                isDeletePrevFilterGroupCount: true,
            });
        }
        // 공유건 채크
        const subscribeHubId = rootGetters['hubSelector/getterSubscribeHubId'];
        oldOrder.setShareOrder(subscribeHubId);
        commit(mutationType.UPDATE_ORDER, oldOrder);
        return oldOrder;
    },
    /**
     * 주문 수량 업데이트
     * 인자로 신규 정보를 가져오고
     * 기존 state 데이터를 이용해서 제거할 상태를 판단한다.
     * @param order 신규 주문 데이터 (현재 스테이트에있는 것이 아닌 새로 받은 데이터여야 함.)
     * @param isPlusFilterGroupCount 현재 필터개수 더하기
     * @param isDeletePrevFilterGroupCount 전 필터개수 빼기
     */
    [actionType.updateStatusOrderCount]({ state, commit, }, { order, isPlusFilterGroupCount, isDeletePrevFilterGroupCount, }) {
        const { payloadType } = order;
        // 카운트 제외 되어야할 페이로드들 추가
        if ([
            socketPayloadType.PICKUP_EXPECTTIME,
        ].includes(payloadType)) {
            return;
        }
        // TODO 목록관제에서 필요 없음
        // const {
        //   isHideShareOrder,
        // } = state.mapVisibilitySetting;
        const prevFilterGroup = orderStatusGroup[order?.preStatusCode] ?? null;
        const prevFilterGroupCount = isDeletePrevFilterGroupCount ? -1 : 0;
        const filterGroup = orderStatusGroup[order.statusCode];
        const filterGroupCount = isPlusFilterGroupCount ? +1 : -1;
        // 순서 중요 (중복시 추가가 되어야 하는 이슈로 인해 순수 중요.)
        const result = {
            [prevFilterGroup]: prevFilterGroupCount,
            [filterGroup]: filterGroupCount,
        };
        // TODO : 자주 사용할 것 같음..ㅜ
        // console.log('current order :', order);
        // console.log('prevFilterGroup :', prevFilterGroup);
        // console.log('currentFilterGroup :', filterGroup);
        // 공유주문, 공유건숨김 대응
        if (order.isShareOrder) {
            // 접수건일 경우
            if (order.isAccepted) {
                // 최초 접수건 > 카운트 반영 x
                if (!prevFilterGroup) {
                    return;
                }
                // 배차, 픽업에서 배차취소된 케이스 > 이전 카운트만 제거 + 주문은 카운트 무시
                if (prevFilterGroup) {
                    result[prevFilterGroup] = -1;
                    result[filterGroup] = 0;
                }
            }
            // 접수건 아닐 경우
            if (!order.isAccepted) {
                // 이전 주문 상태가 접수면 이전 상태값 카운트 반영 x
                if (prevFilterGroup === orderStatus.ACCEPTED.code) {
                    result[prevFilterGroup] = 0;
                    result[filterGroup] = +1;
                }
            }
        }
        let { cardOrderCount } = state;
        // 완료였다가 취소 된 케이스는 카운트 감소
        if (order.isCardOrder
            && order.preStatusCode === orderStatus.DROP_FINISHED.code
            && order.statusCode === orderStatus.CANCELED.code) {
            cardOrderCount -= 1;
            // 완료일 경우 카드건 채크
        }
        else if (order.isCardOrder
            && order.statusCode === orderStatus.DROP_FINISHED.code) {
            cardOrderCount += 1;
        }
        commit(mutationType.SET_CARD_ORDER_COUNT, cardOrderCount);
        commit(mutationType.UPDATE_STATUS_ORDER, result);
    },
    /**
     * 주문 제거
     * @param state
     * @param {orderId, prevStatusCode}
     */
    [actionType.deleteOrder]({ state, commit, dispatch }, orderId) {
        try {
            dispatch(actionType.updateStatusOrderCount, {
                order: state.orderList[orderId],
                isPlusFilterGroupCount: false,
                isDeletePrevFilterGroupCount: false,
            });
            commit('DELETE_ORDER', orderId);
        }
        catch (error) {
            console.dir(error);
        }
    },
    [actionType.inputSearchOrderQuery]({ commit }, query = '') {
        commit('INPUT_SEARCH_ORDER_QUERY', query);
    },
    [actionType.setIsHideShareOrder]({ commit }, isHide) {
        commit('SET_IS_HIDE_SHARE_ORDER', isHide);
    },
    /**
     * 지도에서 배달동선 호버 시 orderId
     */
    [actionType.setMapHoveredOrderId]({ commit }, payload) {
        commit('SET_MAP_HOVERED_ORDER_ID', payload);
    },
    /**
     * 배달거절 스낵바 클릭 시 orderId
     */
    [actionType.setSelectedBySnackbar]({ commit }, payload) {
        commit('SET_SELECTED_BY_SNACKBAR', payload);
    },
    /**
     * 발주 유형, 결제방법 등 검색 연관 값들
     */
    [actionType.setSelectFilter]({ commit }, payload) {
        commit(mutationType.SET_SELECT_FILTER, payload);
    },
    /**
     * 필터 리셋
     */
    [actionType.resetFilter]({ commit }) {
        commit(mutationType.SET_SELECT_FILTER, [
            'orderAgencyType',
            'ALL',
        ]);
        commit(mutationType.SET_SELECT_FILTER, [
            'ownerType',
            'ALL',
        ]);
        commit(mutationType.SET_SELECT_FILTER, [
            'payType',
            'ALL',
        ]);
        commit(mutationType.SET_ORDER_FILTER, [
            orderStatusGroupList.ALL.code,
        ]);
    },
    [actionType.setSortBy]({ commit }, value) {
        commit(mutationType.SET_SORT_BY, value);
    },
};
export default action;
